import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PaginatedContent } from "../common.types";
import { TalentJobOpportunityApi } from "./talent-job-opportunity.api";
import { TalentJobOpportunitySerializer } from "./talent-job-opportunity.serializer";
import {
  TalentJobOpportunity,
  TalentJobOpportunityDTO,
  TalentJobOpportunityFilter,
  TalentJobOpportunityFormFilter,
} from "./talent-job-opportunity.types";

@Injectable({ providedIn: "root" })
export class TalentJobOpportunityService {
  constructor(
    private talentJobOpportunityApi: TalentJobOpportunityApi,
    private talentJobOpportunitySerializer: TalentJobOpportunitySerializer,
  ) {}

  searchTalentJobOpportunities(filter: TalentJobOpportunityFilter): Observable<PaginatedContent<TalentJobOpportunity>> {
    return this.talentJobOpportunityApi
      .searchTalentJobOpportunities(this.talentJobOpportunitySerializer.serializeTalentJobOpportunityFilter(filter))
      .pipe(
        map((paginatedContent) => {
          return {
            ...paginatedContent,
            items: this.talentJobOpportunitySerializer.deserializeTalentJobOpportunities(
              paginatedContent.items as TalentJobOpportunityDTO[],
            ),
            paging: {
              page: paginatedContent.paging.page + 1, // Convert back to 1-based
              itemsOnPage: paginatedContent.paging.itemsOnPage,
              items: paginatedContent.paging.items,
            },
          };
        }),
      );
  }

  searchTalentJobOpportunitiesFromForm(
    formFilter: TalentJobOpportunityFormFilter,
    paging: { page: number; itemsOnPage: number },
  ): Observable<PaginatedContent<TalentJobOpportunity>> {
    return this.talentJobOpportunityApi
      .searchTalentJobOpportunities(this.talentJobOpportunitySerializer.serializeFormFilter(formFilter, paging))
      .pipe(
        map((paginatedContent) => {
          return {
            ...paginatedContent,
            items: this.talentJobOpportunitySerializer.deserializeTalentJobOpportunities(
              paginatedContent.items as TalentJobOpportunityDTO[],
            ),
            paging: {
              page: paginatedContent.paging.page + 1, // Convert back to 1-based
              itemsOnPage: paginatedContent.paging.itemsOnPage,
              items: paginatedContent.paging.items,
            },
          };
        }),
      );
  }

  applyToJobOpportunity(jobOpportunityId: string): Observable<boolean> {
    return this.talentJobOpportunityApi.applyToJobOpportunity(jobOpportunityId);
  }
}
